import { websiteReportSummaryActions } from '../actions/WebsiteReportSummaryActions';
import {
  SEMRushWebsiteCompetitorsModel,
  SEMRushWebsiteSummaryModel,
  SEMRushWebsiteTopLandingsModel,
  SEMRushWebsiteTrafficByMonthModel,
  SEMRushWebsiteTrafficModel,
} from '../model/SEMRushWebsiteTrafficModel';

export type WebsiteReportSummaryState = {
  trafficBusy: boolean;
  trafficLoaded: boolean;
  trafficTotal: SEMRushWebsiteTrafficModel;
  trafficMonthly: SEMRushWebsiteTrafficByMonthModel;
  competitors: SEMRushWebsiteCompetitorsModel[];
  topLandings: SEMRushWebsiteTopLandingsModel[];
  websiteSummary: SEMRushWebsiteSummaryModel;
};

const initialState: WebsiteReportSummaryState = {
  trafficBusy: false,
  trafficLoaded: false,
  trafficTotal: {},
  trafficMonthly: {},
  competitors: [],
  topLandings: [],
  websiteSummary: {},
};

export default function websiteReportSummary(
  state = initialState,
  action: any,
) {
  switch (action.type) {
    case websiteReportSummaryActions.setTrafficLoadedAction:
      return { ...state, trafficLoaded: action.payload };
    case websiteReportSummaryActions.setTrafficTotalsAction:
      return { ...state, trafficTotal: action.payload };
    case websiteReportSummaryActions.setTrafficMonthlyAction:
      return { ...state, trafficMonthly: action.payload };
    case websiteReportSummaryActions.setCompetitorsAction:
      return { ...state, competitors: action.payload };
    case websiteReportSummaryActions.setTopLandingsAction:
      return { ...state, topLandings: action.payload };
    case websiteReportSummaryActions.setWebsiteSummaryAction:
      return { ...state, websiteSummary: action.payload };
    case websiteReportSummaryActions.setTrafficBusyAction:
      return { ...state, trafficBusy: action.payload };
    case websiteReportSummaryActions.resetAction:
      return { ...initialState };
    default:
      return state;
  }
}
